import styled from 'styled-components';

import { theme } from 'components';

const EmptyContainer = styled.div`
  && {
    display: grid;
    align-content: center;
    justify-content: center;
    row-gap: 10px;

    width: 100%;
    height: 100%;

    font-size: 16px;
    line-height: 24px;
    color: ${theme.gray6};
  }
`;

export default EmptyContainer;
